import { createSelector } from 'reselect';

import { Selector } from 'react-redux';
import { RootState } from '../../core/redux/model/rootStateModel';
import { CategoryListGetResponse } from '../../features/category/model/categoryModel';
import { CommonState } from './commonTypes';
import { OptionList, TagGetResponse } from '../model/commonModel';
import { KeywordGetResponse } from '../../features/keyword/model/keywordModel';

const getRoot = (state: RootState) => state.common;

export const categoriesList = createSelector<[Selector<RootState, CommonState>], CategoryListGetResponse[]>(
  getRoot,
  (root: CommonState) => root.categoriesList,
);

export const categoriesOptionList = createSelector<[Selector<RootState, CommonState>], OptionList[]>(
  getRoot,
  (root: CommonState) => {
    return root.categoriesList.map((category) => {
      return {
        value: category.name,
        key: String(category.iri),
      };
    });
  },
);

export const getCategoriesOptionListByParentId = (parentId: number | undefined, categoryId: number | undefined) => {
  return createSelector<[Selector<RootState, CommonState>], OptionList[]>(getRoot, (root: CommonState) => {
    if (!parentId || !root.categoriesList.length) {
      return [];
    }

    return root.categoriesList
      .filter((category) => {
        return category.parent === parentId && category.value !== categoryId;
      })
      .map((category) => {
        return {
          value: category.name,
          key: String(category.iri),
        };
      });
  });
};

export const rootCategoryOption = createSelector<
  [Selector<RootState, CommonState>],
  CategoryListGetResponse | undefined
>(getRoot, (root: CommonState) => {
  return root.categoriesList.find((category) => {
    return !category.parent;
  });
});

export const mainCategoriesOption = createSelector<[Selector<RootState, CommonState>], CategoryListGetResponse[]>(
  getRoot,
  (root: CommonState) => {
    const rootCategoryOption = root.categoriesList.find((category) => {
      return !category.parent;
    });
    return root.categoriesList.filter((category) => {
      return rootCategoryOption ? category.parent === rootCategoryOption.value : false;
    });
  },
);

export const tagsList = createSelector<[Selector<RootState, CommonState>], TagGetResponse[]>(
  getRoot,
  (root: CommonState) => root.tagsList,
);

export const tagsOptionList = createSelector<[Selector<RootState, CommonState>], OptionList[]>(
  getRoot,
  (root: CommonState) => {
    return root.tagsList.map((tag) => {
      return {
        value: tag.name,
        key: tag.iri,
      };
    });
  },
);

export const keywordsList = createSelector<[Selector<RootState, CommonState>], KeywordGetResponse[]>(
  getRoot,
  (root: CommonState) => root.keywordsList,
);

export const keywordsOptionList = createSelector<[Selector<RootState, CommonState>], OptionList[]>(
  getRoot,
  (root: CommonState) => {
    return root.keywordsList.map((keyword) => {
      return {
        value: keyword.name,
        key: keyword.iri,
      };
    });
  },
);

export const rootCategory = createSelector<[Selector<RootState, CommonState>], CategoryListGetResponse | undefined>(
  getRoot,
  (root: CommonState) => {
    return root.categoriesList.find((category) => {
      return !category.parent;
    });
  },
);

export const getCategoryById = (id: number | undefined) => {
  return createSelector<[Selector<RootState, CommonState>], CategoryListGetResponse | undefined>(
    getRoot,
    (root: CommonState) => {
      let test = root.categoriesList.find((category) => {
        return category.value === id;
      });
      return test;
    },
  );
};
